import { STUN_URL, TURN_CREDENTIAL, TURN_URL, TURN_USERNAME } from '../env/env'

export const pageSizeOptions = [10, 50, 100]

//API ERRORS
export const ERROR_500 = 'Something went wrong'

//Roles
export const ROLES = {
  ADMIN: 'admin',
  CONTRIBUTOR: 'contributor',
  MODERATOR: 'moderator',
  CANDIDATE: 'candidate',
  DEVELOPER: 'developer',
  LEARNER: 'learner'
}

export const ROLES_LABEL = {
  ADMIN: 'Admin',
  CONTRIBUTOR: 'Contributor',
  MODERATOR: 'Moderator',
  CANDIDATE: 'Candidate',
  DEVELOPER: 'Developer',
  LEARNER: 'Learner'
}

//Colors for UserStatus
export const userStatusObj = {
  active: 'success',
  pending: 'warning',
  inactive: 'secondary'
}

export const TENANT_PLAN_STATUS_COLORS = {
  ACTIVE: 'success',
  INACTIVE: 'secondary',
  DISABLE: 'error',
  EXPIRED: 'error',
  PAYMENT_PENDING: 'warning',
  PAYMENT_FAILED: 'error',
  CANCELLED: 'error'
}

export const TENANT_PLAN_STATUS_LABEL = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DISABLE: 'Disabled',
  EXPIRED: 'Expired',
  PAYMENT_PENDING: 'Payment Pending',
  CANCELLED: 'Cancelled',
  PAYMENT_FAILED: 'Payment Failed'
}

// candidate status
export const CANDIDATE_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING'
}

// Colors for mcq Question Difficulty
export const DIFFICULTY_COLORS_LABEL_OBJ = {
  EASY: { color: 'success', label: 'Easy' },
  MEDIUM: { color: 'warning', label: 'Medium' },
  HARD: { color: 'error', label: 'Hard' }
}

export const DIFFICULTY_COLORS_LABEL_OBJ_LIGHT = {
  EASY: { color: '#156745', background: '#d0fae5', label: 'Easy' },
  MEDIUM: { color: '#a5551b', background: '#fef3c6', label: 'Medium' },
  HARD: { color: '#9f162d', background: '#ffe2e2', label: 'Hard' }
}

// Extenstion to Language Map for Editore
export const extensionLanguage = {
  js: {
    language: 'javascript',
    icon: 'javascript.svg'
  },
  jsx: {
    language: 'javascript',
    icon: 'javascript-extension.svg'
  },
  ts: {
    language: 'typescript',
    icon: 'typescript.svg'
  },
  tsx: {
    language: 'typescript',
    icon: 'typescript-extension.svg'
  },
  html: {
    language: 'html',
    icon: 'html.svg'
  },
  htm: {
    language: 'html',
    icon: 'html.svg'
  },
  css: {
    language: 'css',
    icon: 'css.svg'
  },
  java: {
    language: 'java',
    icon: 'java.svg'
  },
  py: {
    language: 'python',
    icon: 'python.svg'
  },
  cs: {
    language: 'csharp',
    icon: 'csharp.svg'
  },
  yml: {
    language: 'yaml',
    icon: 'yml.svg'
  },
  sql: {
    language: 'sql',
    icon: 'sql.svg'
  },
  json: {
    language: 'json',
    icon: 'json.svg'
  },
  log: {
    language: 'log',
    icon: 'log.svg'
  }
}

// Comilation Status for showing different color and other details
export const COMPILATION_STATUS = {
  COMPILE_ERROR: { type: 'error' },
  RUN_SUCCESS: { type: 'success' },
  RUN_TIMEOUT: { type: 'warning' },
  RUN_ERROR: { type: 'error' },
  FAILED: { type: 'error' },
  SUCCESS: { type: 'success' },
  TIMEOUT: { type: 'warning' }
}

// Testcase type for Challenge
export const TEST_CASE_TYPE_LABEL = {
  STANDARD_STREAM: 'Input/Output Tests',
  UNIT_TEST: 'Unit Test',
  DBT_TEST: 'DBT Test',
  REST_TEST: 'REST API',
  NONE: 'None'
}

export const STAGE_FIELDS_TO_UPDATE = [
  { key: 'name', defaultValue: '' },
  { key: 'duration', defaultValue: null },
  { key: 'challenges', defaultValue: [] },
  { key: 'challengeId', defaultValue: '' },
  { key: 'psychometricChallenges', defaultValue: [] },
  { key: 'challengeTypeId', defaultValue: '' },
  { key: 'overrideLanguages', defaultValue: [] },
  { key: 'strictSubmission', defaultValue: false },
  { key: 'id', defaultValue: '' },
  { key: 'selectedChallengeType', defaultValue: '' },
  { key: 'filters', defaultValue: {} },
  { key: 'criteria', defaultValue: null },
  { key: 'evaluationSkills', defaultValue: [] },
  { key: 'disableQuestionRevisit', defaultValue: true },
  // below are the keys for dynamic MCQ stage only
  { key: 'sameQuestions', defaultValue: false },
  { key: 'shuffleQuestions', defaultValue: true },
  { key: 'dynamicChallengeConf', defaultValue: [] },
  { key: 'dynamic', defaultValue: false },
  { key: 'penalty', defaultValue: '' },
  { key: 'videoQuestions', defaultValue: [] },
  { key: 'startWindowDuration', defaultValue: null },
  { key: 'startWindowDurationUnit', defaultValue: 'MINUTE' },
  { key: 'challengeSubType', defaultValue: null },
  // Proctoring requirement keys
  { key: 'mediaSharing', defaultValue: false },
  { key: 'screenSharing', defaultValue: false },
  { key: 'useAuxiliaryDevice', defaultValue: false },
  { key: 'enableFullScreenMode', defaultValue: false },
  { key: 'disableCopyPaste', defaultValue: false },
  { key: 'disableContextMenu', defaultValue: false },
  { key: 'disableDualScreenUsage', defaultValue: false },
  // Auto generate Job description field
  { key: 'autoGenerateAiScore', defaultValue: false },
  // Resume filtering keys
  {
    key: 'scoringRules',
    defaultValue: [
      {
        criteria: '',
        weightage: 30
      }
    ]
  },
  { key: 'minimumScore', defaultValue: 70 },
  { key: 'scoreResume', defaultValue: false },
  //Stage Setting keys
  { key: 'autoProgressionScoreType', defaultValue: null },
  { key: 'stageOutcomeStatus', defaultValue: null }
]

export const stageStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  DISQUALIFY: 'DISQUALIFY',
  REJECTED: 'REJECTED',
  CONCLUDED: 'CONCLUDED',
  NO_SHOW: 'NO_SHOW'
}

export const ATTEMPT_STATUS = {
  ...stageStatus,
  ON_HOLD: 'ON_HOLD'
}

export const STAGE_STATUS_LABEL = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  FINISHED: 'Finished',
  DISQUALIFY: 'Disqualified',
  REJECTED: 'Rejected',
  CONCLUDED: 'Concluded',
  NO_SHOW: 'No Show'
}

// USED FOR ATTEMPTS LEVEL
export const ATTEMPT_STATUS_LABEL = {
  ...STAGE_STATUS_LABEL,
  ON_HOLD: 'On Hold'
}

export const STAGE_STATUS_COLOR = {
  IN_PROGRESS: 'var(--warning-main)',
  FINISHED: 'var(--success-main)',
  DISQUALIFY: 'var(--error-main)',
  REJECTED: 'var(--error-main)',
  CONCLUDED: 'var(--primary-main)',
  NO_SHOW: 'var(--alert-main)'
}

// USED FOR ATTEMPTS LEVEL
export const ATTEMPT_STATUS_COLOR = {
  IN_PROGRESS: 'var(--warning-main)',
  FINISHED: 'var(--success-main)',
  DISQUALIFY: 'var(--error-main)',
  REJECTED: 'var(--error-main)',
  CONCLUDED: 'var(--primary-main)',
  NO_SHOW: 'var(--alert-main)',
  ON_HOLD: 'var(--secondary-main)'
}

export const CONTEST_STAGE_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  DISQUALIFY: 'DISQUALIFY',
  REJECTED: 'REJECTED',
  QUALIFIED: 'QUALIFIED',
  SUBMITTED: 'SUBMITTED',
  NO_SHOW: 'NO_SHOW',
  SCHEDULED: 'SCHEDULED',
  NOT_SCHEDULED: 'NOT_SCHEDULED'
}

export const CONTEST_STAGE_STATUS_LABEL = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  FINISHED: 'Finished',
  DISQUALIFY: 'Disqualified',
  REJECTED: 'Rejected',
  SUBMITTED: 'Submitted',
  QUALIFIED: 'Qualified',
  NO_SHOW: 'No Show',
  SCHEDULED: 'Scheduled',
  NOT_SCHEDULED: 'Not Scheduled'
}
export const RESUME_FILTERING_STAGE_STATUS = {
  RESUME_SCREENING: {
    value: 'RESUME_SCREENING',
    label: 'Resume Screening',
    color: 'warning'
  },
  ON_HOLD: { value: 'ON_HOLD', label: 'On Hold', color: 'secondary' },
  REJECTED: { value: 'REJECTED', label: 'Rejected', color: 'error' },
  INVITED: {
    value: 'INVITED',
    label: 'Invited',
    color: 'success'
  },
  FAILED: {
    value: 'FAILED',
    label: 'Failed',
    color: 'error'
  },
  DIRECT_INVITED: {
    value: 'DIRECT_INVITED',
    label: 'Directly Invited',
    color: 'success'
  }
}

export const ASSESSMENT_STAGE_STATUS = {
  SCHEDULED: 'SCHEDULED',
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTED_PENDING_REVIEW: 'SUBMITTED_PENDING_REVIEW',
  SUBMITTED_EVALUATING: 'SUBMITTED_EVALUATING',
  SUBMITTED_NOT_CONCLUDED: 'SUBMITTED_NOT_CONCLUDED',
  FINISHED: 'FINISHED',
  REJECTED_NOT_CONCLUDED: 'REJECTED_NOT_CONCLUDED',
  FINISHED_CONCLUDED: 'FINISHED_CONCLUDED',
  REJECTED_CONCLUDED: 'REJECTED_CONCLUDED',
  NOT_SCHEDULED: 'NOT_SCHEDULED',
  NO_SHOW: 'NO_SHOW',

  // not used in assessment dashboard but are being used
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  SYSTEM_CHECK_PENDING: 'SYSTEM_CHECK_PENDING',
  SYSTEM_CHECK_SKIPPED: 'SYSTEM_CHECK_SKIPPED',
  SYSTEM_CHECK_PASSED: 'SYSTEM_CHECK_PASSED',
  SYSTEM_CHECK_FAILED: 'SYSTEM_CHECK_FAILED',
  IN_VALIDATED: 'IN_VALIDATED',
  UNKNOWN: 'UNKNOWN',

  // RESUME FILTERING STATUSES
  RESUME_SCREENING: 'RESUME_SCREENING',
  ON_HOLD: 'ON_HOLD',
  INVITED: 'INVITED'
}

export const ASSESSMENT_STAGE_STATUS_LABEL = {
  SCHEDULED: 'Scheduled',
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  SUBMITTED_PENDING_REVIEW: 'Submitted - Pending Review',
  SUBMITTED_EVALUATING: 'Submitted - Evaluating',
  SUBMITTED_NOT_CONCLUDED: 'Submitted (Not Concluded)',
  FINISHED: 'Finished',
  REJECTED_NOT_CONCLUDED: 'Rejected (Not Concluded)',
  FINISHED_CONCLUDED: 'Finished Concluded',
  REJECTED_CONCLUDED: 'Rejected (Concluded)',
  NOT_SCHEDULED: 'Not Scheduled',
  NO_SHOW: 'No Show',

  // not used in assessment dashboard but are being used
  EMAIL_NOT_VERIFIED: 'Email Not Verified',
  EMAIL_VERIFIED: 'Email verified',
  SYSTEM_CHECK_PENDING: 'System Check Pending',
  SYSTEM_CHECK_SKIPPED: 'System Check Skipped',
  SYSTEM_CHECK_PASSED: 'System Check Passed',
  SYSTEM_CHECK_FAILED: 'System Check Failed',
  IN_VALIDATED: 'Invite Cancelled',
  UNKNOWN: 'Unknown',

  // RESUME FILTERING STATUSES
  RESUME_SCREENING: 'Resume Screening',
  ON_HOLD: 'On Hold',
  INVITED: 'Invited ',
  REJECTED: 'Rejected',
  FAILED: 'Failed',
  DIRECT_INVITED: 'Directly Invited'
}

export const ASSESSMENT_STAGE_STATUS_COLOR = {
  SCHEDULED: '',
  NOT_STARTED: '',
  IN_PROGRESS: 'info',
  SUBMITTED_PENDING_REVIEW: 'info',
  SUBMITTED_EVALUATING: 'info',
  SUBMITTED_NOT_CONCLUDED: 'info',
  FINISHED: 'success',
  REJECTED_NOT_CONCLUDED: 'error',
  FINISHED_CONCLUDED: 'success',
  REJECTED_CONCLUDED: 'error',
  NOT_SCHEDULED: '',
  NO_SHOW: 'alert',

  // not used in assessment dashboard but are being used
  EMAIL_NOT_VERIFIED: 'warning',
  EMAIL_VERIFIED: 'success',
  SYSTEM_CHECK_PENDING: 'warning',
  SYSTEM_CHECK_SKIPPED: 'primary',
  SYSTEM_CHECK_PASSED: 'success',
  SYSTEM_CHECK_FAILED: 'error',
  IN_VALIDATED: 'error',
  UNKNOWN: '',

  // RESUME FILTERING STATUSES
  RESUME_SCREENING: 'warning',
  ON_HOLD: 'secondary',
  INVITED: 'success',
  REJECTED: 'error',
  FAILED: 'error'
}

export const EXCLUDE_STATUS_IN_ASSESSMENT_DASHBOARD = [
  'EMAIL_NOT_VERIFIED',
  'EMAIL_VERIFIED',
  'SYSTEM_CHECK_PENDING',
  'SYSTEM_CHECK_SKIPPED',
  'SYSTEM_CHECK_PASSED',
  'SYSTEM_CHECK_FAILED',
  'IN_VALIDATED',
  'UNKNOWN',
  // Resume filtering statuses
  'RESUME_SCREENING',
  'INVITED'
]

export const CHALLENGE_TYPES = {
  DBT: 'DBT',
  SQL: 'SQL',
  PROGRAMMING: 'PROGRAMMING',
  MCQ: 'MCQ',
  APPLICATION: 'APPLICATION',
  NOTEBOOK: 'NOTEBOOK',
  INTERVIEW: 'INTERVIEW',
  PLACEMENT_TALK: 'PLACEMENT_TALK',
  HTML: 'HTML',
  MARKDOWN: 'MARKDOWN',
  AI_SCREENING: 'AI_SCREENING',
  VIDEO_RESPONSE: 'VIDEO_RESPONSE',
  PSYCHOMETRIC: 'PSYCHOMETRIC',
  RESUME_FILTERING: 'RESUME_FILTERING'
}

export const CHALLENGE_TYPE_ID = {
  MCQ: 1,
  PROGRAMMING: 2,
  APPLICATION: 3,
  NOTEBOOK: 4,
  INTERVIEW: 5,
  PLACEMENT_TALK: 6,
  SQL: 7,
  DBT: 8,
  AI_SCREENING: 9,
  VIDEO_RESPONSE: 10,
  RESUME_FILTERING: 11,
  PSYCHOMETRIC: 12
}
export const CHALLENGE_TYPE_FROM_ID = {
  1: { value: 'MCQ', label: 'MCQ' },
  2: { value: 'PROGRAMMING', label: 'Programming' },
  3: { value: 'APPLICATION', label: 'Application' },
  4: { value: 'NOTEBOOK', label: 'Notebook' },
  5: { value: 'INTERVIEW', label: 'Interview' },
  6: { value: 'PLACEMENT_TALK', label: 'Pre-Placement Talk' },
  7: { value: 'SQL', label: 'SQL' },
  8: { value: 'DBT', label: 'DBT' },
  9: { value: 'AI_SCREENING', label: 'AI Interview' },
  10: { value: 'VIDEO_RESPONSE', label: 'Video Response' },
  11: { value: 'RESUME_FILTERING', label: 'Profile Screening' },
  12: { value: 'PSYCHOMETRIC', label: 'Psychometric' }
}

// get label for challengeType
export const CHALLENGE_TYPE_LABEL = {
  MCQ: 'MCQ',
  SQL: 'SQL',
  DBT: 'DBT',
  PROGRAMMING: 'Programming',
  APPLICATION: 'Application',
  NOTEBOOK: 'Notebook',
  INTERVIEW: 'Interview',
  PLACEMENT_TALK: 'Pre-Placement Talk',
  HTML: 'HTML',
  MARKDOWN: 'Markdown',
  AI_SCREENING: 'AI Interview',
  VIDEO_RESPONSE: 'Video Response',
  PSYCHOMETRIC: 'Psychometric',
  RESUME_FILTERING: 'Profile Screening'
}

export const PSYCHOMETRIC_COLORS = [
  '#8e24aa', // purple
  '#1e88e5', // blue
  '#43a047', // green
  '#fb8c00', // orange
  '#e53935', // red
  '#7c3aed', // violet
  '#00acc1', // cyan
  '#fdd835', // yellow
  '#3949ab', // indigo
  '#d81b60' // pink
]

export const PSYCHOMETRIC_TRAIT_LABELS = {
  DOMINANCE: 'Dominance',
  INFLUENCE: 'Influence',
  STEADINESS: 'Steadiness',
  CONSCIENTIOUSNESS: 'Conscientiousness',
  OPENNESS: 'Openness',
  EXTRAVERSION: 'Extraversion',
  AGREEABLENESS: 'Agreeableness',
  NEUROTICISM: 'Neuroticism'
}

export const PSYCHOMETRIC_STATUS = {
  INSUFFICIENT_DATA: 'INSUFFICIENT_DATA',
  COMPLETED: 'COMPLETED'
}

export const CHALLENGE_TESTCASE_TYPE = {
  UNIT_TEST: 'UNIT_TEST',
  STANDARD_STREAM: 'STANDARD_STREAM',
  DBT_TEST: 'DBT_TEST',
  REST_TEST: 'REST_TEST',
  NONE: 'NONE'
}

export const CHALLENGE_TYPE_ICON = {
  INITIAL: 'fluent-emoji:unlocked',
  DBT: 'logos:dbt-icon',
  SQL: 'vscode-icons:file-type-sql',
  PROGRAMMING: 'vscode-icons:file-type-dtd',
  VIDEO_RESPONSE: 'fluent-color:video-28',
  MCQ: 'fluent-color:text-edit-style-24',
  APPLICATION: 'catppuccin:java-class-sealed',
  NOTEBOOK: 'devicon:jupyter-wordmark',
  INTERVIEW: 'fluent-color:patient-24',
  PLACEMENT_TALK: 'fluent-color:people-28',
  AI_SCREENING: 'fluent-color:bot-sparkle-16',
  RESULT: 'twemoji:bar-chart',
  RESUME_FILTERING: 'fluent-color:layer-diagonal-person-16',
  PSYCHOMETRIC: 'streamline-color:brain',
  ALL: 'fluent-color:people-team-24'
}

export const FILTER_IF_EXISTS = [
  CHALLENGE_TYPE_ID.AI_SCREENING,
  CHALLENGE_TYPE_ID.RESUME_FILTERING,
  CHALLENGE_TYPE_ID.PSYCHOMETRIC
]

export const EXCLUDE_CHALLENGE_TYPES_FROM_NAMES = [
  CHALLENGE_TYPE_ID.RESUME_FILTERING,
  CHALLENGE_TYPE_ID.PLACEMENT_TALK,
  CHALLENGE_TYPE_ID.PSYCHOMETRIC
]

export const EXCLUDED_STRICT_SUBMISSION_TYPES = [
  CHALLENGE_TYPE_ID.PLACEMENT_TALK,
  CHALLENGE_TYPE_ID.AI_SCREENING,
  CHALLENGE_TYPE_ID.INTERVIEW,
  CHALLENGE_TYPE_ID.VIDEO_RESPONSE,
  CHALLENGE_TYPE_ID.RESUME_FILTERING
]

// languages svg logo to label mapping
export const languagesLogoFromLabel = {
  dbt: 'dbt.svg',
  javascript: 'javascript.svg',
  java: 'java.svg',
  python: 'python.svg',
  react: 'react.svg',
  'nextjs-web': 'nextjs.svg',
  'nextjs-api': 'nextjs.svg',
  csharp: 'csharp.svg',
  angular: 'angular.svg',
  postgres: 'postgres.svg',
  typescript: 'typescript.svg',
  'web-basic': 'html.svg',
  'jupyter-notebook': 'jupyter.svg',
  flask: 'flask.svg',
  expressjs: 'express.svg',
  nestjs: 'nestjs.svg',
  fastapi: 'fastapi.svg',
  sql: 'sql.svg'
}

export const currencyMap = {
  USD: '$',
  INR: '₹',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: 'A$',
  CAD: 'C$'
}

export const currencyLocaleMap = {
  INR: 'en-IN',
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  JPY: 'ja-JP',
  AUD: 'en-AU',
  CAD: 'en-CA'
}

export const YEARS__OF__EXPERIENCE = ['0-2 years', '3-4 years', '5+ years']

export const PURCHASE_ERROR_CODE = {
  4000: 'Invalid Payment Details',
  4009: 'Max Subscriptions already purchased',
  5000: 'Payment Processing Failed',
  5001: 'External Payment Gateway Error',
  5003: 'Payment Service Unavailable',
  6003: 'Invalid Token',
  6004: 'Payment not Authorized yet'
}

export const PURCHASE_SUCCESS_CODE = {
  2000: 'Payment Processed Successfully',
  2001: 'Payment Already Captured'
}

export const LANGUAGE_MAIN_FILE = {
  java: 'Main.java',
  javascript: 'index.js',
  typescript: 'index.ts',
  python: 'main.py',
  csharp: 'Program.cs'
}

export const LANGUAGE_FILE_EXTENSION = {
  java: 'java',
  javascript: 'js',
  typescript: 'ts',
  python: 'py',
  csharp: 'cs'
}

export const LANGUAGE_PREFIX_FILE_PATH = {
  java: 'src/main/java/',
  python: 'src/',
  javascript: 'src/',
  typescript: 'src/',
  csharp: 'src/'
}

export const EDITOR_DEFAULT_LANGUAGE_FILES = {
  react: [
    {
      path: 'src',
      isFolder: true
    }
  ],
  flask: [
    {
      path: 'src',
      isFolder: true
    }
  ],
  expressjs: [
    {
      path: 'src',
      isFolder: true
    }
  ],
  nestjs: [
    {
      path: 'src',
      isFolder: true
    }
  ],
  fastapi: [
    {
      path: 'src',
      isFolder: true
    }
  ],
  dbt: [
    {
      path: 'macros',
      isFolder: true
    },
    {
      path: 'models',
      isFolder: true
    },
    {
      path: 'tests',
      isFolder: true
    }
  ],
  java: [
    {
      path: 'src/main/java',
      isFolder: true
    },
    {
      path: 'src/test/java',
      isFolder: true,
      unitTest: true
    }
  ],
  python: [
    {
      path: 'src',
      isFolder: true
    },
    {
      path: 'src',
      isFolder: true,
      unitTest: true
    }
  ],
  javascript: [
    {
      path: 'src',
      isFolder: true
    }
  ],
  typescript: [
    {
      path: 'src',
      isFolder: true
    }
  ],
  csharp: [
    {
      path: 'src',
      isFolder: true
    },
    {
      path: 'test',
      isFolder: true,
      unitTest: true
    }
  ],
  'web-basic': [
    {
      path: 'index.html'
    },
    {
      path: 'index.css'
    },
    {
      path: 'index.js'
    }
  ]
}

export const QUESTION_CONTENT_TYPE_MAP = {
  PLAIN_TEXT: 'PLAIN_TEXT',
  HTML: 'HTML',
  MARKDOWN: 'MARKDOWN'
}

export const QUESTION_CONTENT_TYPE = [
  { label: 'Plain text ', value: 'PLAIN_TEXT' },
  { label: 'HTML ', value: 'HTML' },
  { label: 'Markdown', value: 'MARKDOWN' }
]

export const QUESTION_SUB_TYPE = [
  { label: 'MCQ', value: 'MCQ' },
  { label: 'Short Answer', value: 'SHORT_ANSWER' },
  { label: 'Comprehension', value: 'COMPREHENSION' }
]

export const QUESTION_SUB_TYPE_MAP = {
  MCQ: 'MCQ',
  SHORT_ANSWER: 'SHORT_ANSWER',
  COMPREHENSION: 'COMPREHENSION'
}
export const QUESTION_SUB_TYPE_LABEL = {
  MCQ: 'MCQ',
  SHORT_ANSWER: 'Short Answer',
  COMPREHENSION: 'Comprehension'
}
export const QUESTION_DIFFICULTY = [
  { label: 'Easy', value: 'EASY' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'Hard', value: 'HARD' }
]

export const QUESTION_DIFFICULTY_LABEL = Object.fromEntries(
  QUESTION_DIFFICULTY.map((item) => [item.value, item?.label])
)

// candidate result status
export const CANDIDATE_RESULT_STATUS = {
  PENDING_MANUAL: 'PENDING_MANUAL',
  AVAILABLE: 'AVAILABLE'
}

export const SUBSCRIPTION_PLANS = {
  TRIAL: 'Trial',
  STARTER: 'Starter',
  PRO: 'Pro',
  GROWTH: 'Growth',
  ENTERPRISE: 'Enterprise'
}

export const suspiciousActivityKey = [
  { event: 'codePasted', label: '%s times pasted the code in editor' },
  { event: 'ipAddressChange', label: '%s times candidate ip address changed' }
]

export const TIMELINE_EVENT_KEY = [
  'runCode',
  'run-sql',
  'codePasted',
  'tabSwitch',
  'dependencyChange',
  'ipAddressChange',
  'question-changed',
  'candidateRemark',
  'manualLeave',
  'gazeSegments',
  'aiInterviewer'
  // 'stageFinished'
]

export const TIMELINE_EVENT_KEY_LABEL = {
  runCode: 'Run Code',
  gazeSegments: 'Gaze Direction',
  aiInterviewer: 'AI Interviewer',
  'run-sql': 'Run SQL',
  codePasted: 'Code Pasted',
  tabSwitch: 'Tab Switch',
  ipAddressChange: 'IP Address Change',
  noFaceDetected: 'Face Not Detected',
  dependencyChange: 'Dependency Change',
  'question-changed': 'Question Changed',
  candidateRemark: 'Candidate Remark',
  developerTag: 'Developer Tag',
  manualLeave: 'Manual Leave',
  stageFinished: 'Stage Finished'
}

// dont change index for app as it is used for re-direction logic for switch-tenant
export const RESERVED_SUBDOMAINS = ['dev', 'app', 'prodtest']

export const DOMAIN = 'coderscout.io'

export const audioStreamCodes = {
  codecOptions: {
    opusStereo: true,
    opusDtx: true,
    opusFec: true,
    opusNack: true
  }
}

export const videoStreamCodecs = {
  codecOptions: {
    videoGoogleStartBitrate: 1500,
    videoGoogleMaxBitrate: 2500,
    videoGoogleMinBitrate: 500
  },
  encodings: [
    {
      rid: 'r0',
      maxBitrate: 150000,
      scalabilityMode: 'L3T3',
      dtx: true
    },
    {
      rid: 'r1',
      maxBitrate: 500000,
      scalabilityMode: 'L3T3',
      dtx: true
    },
    {
      rid: 'r2',
      maxBitrate: 1500000,
      scalabilityMode: 'L3T3',
      dtx: true
    }
  ]
}

export const interviewVideoStreamCodecs = {
  codecOptions: {
    videoGoogleStartBitrate: 2000,
    videoGoogleMaxBitrate: 5000,
    videoGoogleMinBitrate: 1000
  },
  encodings: [
    {
      rid: 'r0',
      maxBitrate: 500000, // Increase base quality bitrate
      scalabilityMode: 'L3T3',
      dtx: true
    },
    {
      rid: 'r1',
      maxBitrate: 1000000, // Mid-level quality
      scalabilityMode: 'L3T3',
      dtx: true
    },
    {
      rid: 'r2',
      maxBitrate: 3000000, // High-level quality for better clarity
      scalabilityMode: 'L3T3',
      dtx: true
    }
  ]
}

export const themeColors = [
  '#1E90FF',
  '#0071A4',
  '#333333',
  '#20A271',
  '#CC5500',
  '#FFC300'
]

export const compilationErrorType = [
  'FAILED',
  'RUN_ERROR',
  'RUN_TIMEOUT',
  'COMPILE_ERROR',
  'COMPILE_TIMEOUT'
]

export const extensionsIncludedInDBTDisplayFiles = ['json', 'log', 'sql', 'yml']

export const QUESTION_IMPORT_OPTIONS = [
  {
    id: 'xlsx',
    donwloadExtension: 'xlsx',
    icon: 'vscode-icons:file-type-excel',
    label: 'Excel',
    downloadLabel: 'Download XLSX sample data',
    fileType: 'excel',
    title: 'Upload XLSX or XLS file',
    validExtensions: ['xlsx', 'xls', 'csv', 'json'],
    acceptAttribute:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv, application/json',
    errorMessage: 'Allowed file extension are .xlsx and .xls'
  },
  {
    id: 'csv',
    donwloadExtension: 'csv',
    icon: 'catppuccin:csv',
    label: 'CSV',
    downloadLabel: 'Download CSV sample data',
    fileType: 'csv',
    title: 'Upload CSV file',
    validExtensions: ['xlsx', 'xls', 'csv', 'json'],
    acceptAttribute:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv, application/json',
    errorMessage: 'Allowed file extension is .csv'
  },
  {
    id: 'json',
    donwloadExtension: 'json',
    icon: 'vscode-icons:file-type-light-json',
    label: 'JSON',
    fileType: 'json',
    downloadLabel: 'Download JSON sample data',
    validExtensions: ['xlsx', 'xls', 'csv', 'json'],
    acceptAttribute:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv, application/json',
    errorMessage: 'Allowed file extension is .json',
    title: 'Upload JSON file'
  },
  {
    id: 'mettl',
    donwloadExtension: 'xlsx',
    label: 'Mettl',
    isCustom: true,
    icon: 'icon-park:file-code',
    validExtensions: ['xlsx', 'xls'],
    acceptAttribute:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    errorMessage: 'Allowed file extension are .xlsx and .xls',
    fileType: 'excel',
    title: 'Upload file from Mettl',
    imgSrc: 'https://dheqrk50tsrf3.cloudfront.net/logos/mettl-logo.png'
  }
]

export const APP_MODES_DATA = [
  {
    label: 'Hiring',
    value: 'hiring',
    icon: 'tdesign:user-search',
    displayLabel: 'For Hiring'
  },
  {
    label: 'Learning',
    value: 'learning',
    icon: 'mdi:learn-outline',
    displayLabel: 'For Learning'
  }
]

export const APP_MODE = {
  HIRING: 'hiring',
  LEARNER: 'learning'
}

export const COURSE_DIFFICULTY = {
  BEGINNER: { label: 'Beginner', color: 'success', index: 0 },
  INTERMEDIATE: { label: 'Intermediate', color: 'warning', index: 1 },
  EXPERT: { label: 'Expert', color: 'error', index: 2 }
}

export const CHALLENGES_FILTERS = {
  page: 0,
  name: '',
  sortBy: 'createdTimestamp',
  sortDir: 'desc',
  tenantId: '',
  pageSize: 50,
  includeLibrary: [],
  challengeTypeId: '',
  mode: APP_MODE.HIRING.toUpperCase(),
  isLive: null,
  difficulty: null
}

export const CONTEST_LIST_FILTERS = {
  page: 0,
  search: '',
  size: 50,
  tenantId: ''
}

export const DBT_DEFAULT_COMMAND = 'dbt build --warn-error'

export const REGISTRATION_FORM_COMPONENT_TYPES_OPTIONS = [
  { value: 'text', label: 'Text' },
  { value: 'email', label: 'Email' },
  { value: 'number', label: 'Number' },
  { value: 'resume', label: 'Resume' },
  { value: 'dropdown', label: 'Dropdown' },
  { value: 'multi_select_dropdown', label: 'Multi Select Dropdown' },
  { value: 'file', label: 'File' },
  { value: 'date', label: 'Date' },
  { value: 'url', label: 'URL' }
]

export const REGISTRATION_FORM_COMPONENT_TYPES_LABEL_MAP = Object.fromEntries(
  REGISTRATION_FORM_COMPONENT_TYPES_OPTIONS.map((item) => [
    item?.value,
    item?.label
  ])
)

export const REGISTRATION_FORM_COMPONENT_TYPES_VALUE_MAP = Object.fromEntries(
  REGISTRATION_FORM_COMPONENT_TYPES_OPTIONS.map((item) => [
    item?.label,
    item?.value
  ])
)

export const REGISTRATION_FORM_CRITERIA_OPTIONS = [
  { value: '', label: 'No criteria' },
  { value: '>', label: 'Greater than' },
  { value: '>=', label: 'Greater than or Equal' },
  { value: '<', label: 'Less than' },
  { value: '<=', label: 'Less than or Equal' },
  { value: '=', label: 'Equal' }
]

export const REGISTRATION_FORM_CRITERIA_LABEL_MAP = Object.fromEntries(
  REGISTRATION_FORM_CRITERIA_OPTIONS.map((item) => [item?.value, item?.label])
)

export const REGISTRATION_FORM_FILE_TYPE_OPTIONS = [
  { value: '.jpg', label: 'JPG' },
  { value: '.jpeg', label: 'JPEG' },
  { value: '.png', label: 'PNG' },
  { value: '.pdf', label: 'PDF' },
  { value: '.docx', label: 'DOC' }
]

export const REGISTRATION_FORM_FILE_TYPE_OPTIONS_VALUE_MAP = Object.fromEntries(
  REGISTRATION_FORM_FILE_TYPE_OPTIONS.map((item) => [item?.value, item?.label])
)

export const REGISTRATION_FORM_FILE_TYPE_OPTIONS_KEY_MAP = Object.fromEntries(
  REGISTRATION_FORM_FILE_TYPE_OPTIONS.map((item) => [item?.label, item?.value])
)

export const TIME_FORMATS = ['DAY', 'WEEK', 'MONTH', 'YEAR']

export const WEBSITE_URL = 'https://coderscout.io'

export const AI_SCREENING_ROLES = {
  AI: 'AI',
  HUMAN: 'HUMAN'
}

export const AI_SESSSION_STATE = {
  THINKING: { value: 'THINKING', label: 'Thinking', className: 'thinking' },
  LISTENING: { value: 'LISTENING', label: 'Listening', className: 'listening' },
  SPEAKING: { value: 'SPEAKING', label: 'Speaking', className: 'speaking' },
  USER_SPEAKING: {
    value: 'USER_SPEAKING',
    label: 'Listening to you',
    className: 'listening'
  }
}

export const WARNING_OPTIONS = [
  {
    label: 'Cheating Detected',
    value:
      'We’ve detected suspicious behavior. Please avoid using unauthorized tools or assistance. This is your warning.'
  },
  {
    label: 'Tab Switch Warning',
    value:
      'Switching tabs during the test is not allowed. Please stay focused on the current window.'
  },
  {
    label: 'Final Warning',
    value:
      'This is your final warning. Any further violation may result in disqualification.'
  },
  {
    label: 'Inactivity Alert',
    value:
      "You've been inactive for a while. Please continue with the test or it may be flagged."
  },
  {
    label: 'Webcam Issue',
    value:
      'Your webcam stream appears disrupted or inactive. Please ensure your face is clearly visible throughout the test.'
  },

  {
    label: 'Device Violation',
    value:
      'Use of mobile phones or multiple devices is strictly prohibited. Continuing may result in disqualification.'
  }
]

export const IFRAME_SANITIZATION_OPTIONS = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['src', 'frameborder', 'allowfullscreen', 'width', 'height'],
  ALLOWED_URI_REGEXP: /^https:\/\/app\.fabric\.microsoft\.com\//
}

export const deadlineUnitData = [
  { label: 'minute', value: 'MINUTE' },
  { label: 'hour', value: 'HOUR' },
  { label: 'day', value: 'DAY' }
]
// userTourSteps.js

export const userTourHomeSteps = [
  {
    element: '#watch-guide-btn',
    popover: {
      title: 'Watch Product Overview',
      description:
        'Get a complete walkthrough of how to use CoderScout in just a few minutes. Click here to watch a quick guide.'
    }
  },
  {
    element: '#contests',
    popover: {
      title: 'Contests',
      description:
        "Contests let you find top performing candidates by assessing candidates' real-world problem-solving skills. Great for campus hiring / off campus hiring drives."
    }
  },
  {
    element: '.campus-hiring',
    popover: {
      title: 'Campus Hiring',
      description:
        'Effortlessly conduct campus drives by inviting 1000+ students to participate in a single contest. Track participation, scores, and performance at scale.'
    }
  },
  {
    element: '#assessments',
    popover: {
      title: 'Assessments',
      description:
        'Assessments lets you assess candidates for any skill / experience level. Create customized multi-stage assessments for specialized roles. Web developers, Backend developers, Data engineers and data scientists.'
    }
  },
  {
    element: '.lateral-hiring',
    popover: {
      title: 'Lateral Hiring',
      description:
        'Evaluate experienced candidates using Assessments. Design assessments for niche skills & roles using our extensive library of challenges.'
    }
  },
  {
    element: '#credits-info',
    popover: {
      title: 'How Credits Work',
      description:
        'Credits are used only when a candidate starts a specific stage of contest or assessment. No credits are consumed when you create contests, assessments.'
    }
  }
]

export const userTourContestSteps = {
  step_1: [
    {
      element: '.is-job-opening-checkbox',
      popover: {
        title: 'Enable Job Opening',
        description: `Enable this option to create a new job opening by filling in the required details. The system will automatically generate the job listing based on your input.`
      }
    },
    {
      element: '.job-opening-section',
      popover: {
        title: 'Job Opening Section',
        description: `<b>Job Title</b> : Enter the title of the job, such as “Software Engineer” or “Project Manager.” This helps candidates quickly identify the role being offered.<br>
<b>Core Skills</b> : Specify the key skills required for this position — for example, programming languages, problem-solving, or communication skills. You can select from a predefined list or add your own.<br>
<b>Good To Have</b> : Add any additional skills or experiences that would be beneficial but are not mandatory for the role.<br>
<b>Qualifications</b> : Mention the required educational background, degrees, certifications, or relevant training necessary for the position.<br>
<b>Experience</b> : Indicate the level of experience expected, such as the number of years in a similar position or industry. You can select it from a dropdown or enter it manually.`
      }
    },
    {
      element: '.requirement-section',
      popover: {
        title: 'Requirement Section',
        description: `
        <b>Job Description</b> : In this section, describe the responsibilities and key tasks for the job. Be clear and concise so applicants know what to expect.<br><br>
          <b>Roles and Responsibilities</b> : List the specific responsibilities associated with the job. This helps to provide a detailed overview of what the applicant will be doing on a daily basis.
        `
      }
    },
    {
      element: '.other-information-section',
      popover: {
        title: 'Other Information Section',
        description: `<b>About the Company</b> : This field gives you the space to describe your company, its mission, and what makes it unique. Feel free to share information about your company’s values, culture, and vision. The more information here, the better!<br>
        `
      }
    },
    {
      element: '.MuiAccordion-root',
      popover: {
        title: 'Position Information Section',
        description: `<b>Job Type</b> : Here, specify the type of employment (e.g., Full-time, Part-time, Freelance, etc.).<br><br>
        <b>Locations</b> : Add the location(s) where the job is based, or if it’s remote, mention that here.<br><br>
        <b>Number of Positions</b> : Enter the number of positions available for this job opening.<br><br>
        <b>Salary</b> : Add the expected salary for the role. This can be a range or a fixed number.<br>`
      }
    },
    {
      element: '.next-btn',
      popover: {
        title: 'Generate Stages',
        description: `<b>Auto Generate</b> :Use AI to build a multi-stage contest or Build Manually to generate stages for your contest. You can always edit the stages later.<br>`
      }
    }
  ],
  step_2: [
    {
      element: '#automate-stage-progression',
      popover: {
        title: 'Automate Stage Progression',
        description:
          'Enable this option to automatically move candidates to the next stage based on performance.',
        position: 'right'
      }
    },
    {
      element: '#add-stage-button',
      popover: {
        title: 'Add Stage',
        description: 'Click here to add a new stage to your contest.',
        position: 'left'
      }
    },
    {
      element: '#stage-flow',
      popover: {
        title: 'Stage Flow',
        description:
          'View and manage the flow of different stages in the contest.',
        position: 'top'
      }
    },
    {
      element: '.next-btn',
      popover: {
        title: 'Next',
        description:
          'Click to proceed to the next step once the stages are configured.',
        position: 'top'
      }
    }
  ],
  step_3: [
    {
      element: '#contest-name-input',
      popover: {
        title: 'Contest Name',
        description:
          'Enter a unique name for your contest or assessment. This is mandatory.',
        position: 'right'
      }
    },
    {
      element: '#contest-url-input',
      popover: {
        title: 'Contest URL',
        description:
          'A public-facing link for your contest is automatically generated here.',
        position: 'right'
      }
    },
    {
      element: '#proctoring-settings',
      popover: {
        title: 'Proctoring Requirements',
        description:
          'Enable these options to monitor candidates during the contest.',
        position: 'top'
      }
    },
    {
      element: '#practice-challenge-select',
      popover: {
        title: 'Practice Challenge',
        description:
          'Optionally assign a practice challenge before the contest.',
        position: 'bottom'
      }
    },
    {
      element: '#perform-system-checks',
      popover: {
        title: 'System Checks',
        description:
          'Enable this to ensure the candidate’s system is ready before the contest.',
        position: 'left'
      }
    },
    {
      element: '#contest-start-time',
      popover: {
        title: 'Contest Start Time',
        description: 'Set the date and time when your contest will begin.',
        position: 'right'
      }
    }
  ],
  step_4: [
    {
      element: '#invite-candidate',
      popover: {
        title: 'Candidates Invite',
        description:
          'Invite candidates to your contest or assessment by email addresses.'
      }
    },
    {
      element: '#register-candidate',
      popover: {
        title: 'Application Form',
        description:
          'Create a application form for candidates to fill out before they can join the contest.'
      }
    }
  ]
}

export const EMAIL_TEMPLATE_TYPES = {
  INVITATION: 'INVITATION'
}

export const ALLOWED_STAGES_FOR_SBW = [
  //START BY WINDOW ALLOWED STAGES
  CHALLENGE_TYPE_ID.AI_SCREENING,
  CHALLENGE_TYPE_ID.APPLICATION,
  CHALLENGE_TYPE_ID.DBT,
  CHALLENGE_TYPE_ID.MCQ,
  CHALLENGE_TYPE_ID.PROGRAMMING,
  CHALLENGE_TYPE_ID.NOTEBOOK,
  CHALLENGE_TYPE_ID.SQL,
  CHALLENGE_TYPE_ID.VIDEO_RESPONSE,
  CHALLENGE_TYPE_ID.PSYCHOMETRIC
]
export const APPLICATION_SUBTYPES = {
  WEB_BASIC: 'WEB_BASIC',
  WEB_FRAMEWORK: 'WEB_FRAMEWORK',
  REST_API: 'REST_API'
}

export const needFullQualityVideoPath = [
  '/ppt-stage/',
  '/interview-stage/',
  '/ai-screening-stage/'
]

export const isEnableData = [
  { value: true, label: 'Enable Now' },
  { value: false, label: 'Schedule Later' }
]

export const AI_SOLUTION_ICONS = {
  gemini: 'material-icon-theme:gemini-ai',
  chatgpt: 'hugeicons:chat-gpt',
  claude: 'material-icon-theme:claude',
  perplexity: 'ri:perplexity-line',
  default: 'eos-icons:ai'
}

export const ICE_SERVERS = [
  {
    urls: STUN_URL
  },
  {
    urls: TURN_URL,
    username: TURN_USERNAME,
    credential: TURN_CREDENTIAL
  }
]

export const RESUME_POOL_PARSING_STATUS = {
  PENDING: { value: 'PENDING', label: 'Pending', color: 'secondary' },
  IN_PROGRESS: { value: 'IN_PROGRESS', label: 'In Progress', color: 'warning' },
  COMPLETED: { value: 'COMPLETED', label: 'Completed', color: 'success' },
  FAILED: { value: 'FAILED', label: 'Failed', color: 'error' }
}

export const ALL_CANDIDATES_ID = -4

export const candidateContestLeaveWarning = `
      <div style="text-align: left;">
        <p style="margin-bottom: 16px; font-size: 18px; font-weight: 600;">You're About to Leave the Stage</p>
        <p style="margin-bottom: 12px;">Leaving this stage will <strong>NOT</strong> pause the timer, this stage will be submitted as-is when the timer runs out. You may not be able to give this stage again.</p>
        <p style="margin-top: 16px;">Are you sure you want to leave this stage?</p>
      </div>
    `

export const CANDIDATE_TAB_STATUS_FILTER_OPTIONS = [
  { label: 'Email not verified', value: 'EMAIL_NOT_VERIFIED' },
  { label: 'Email verified', value: 'EMAIL_VERIFIED' },
  { label: 'Invite Cancelled', value: 'IN_VALIDATED' }
]

export const SYSTEM_CHECKS_FILTER_OPTIONS = [
  ...CANDIDATE_TAB_STATUS_FILTER_OPTIONS?.filter((item) => {
    return item?.value !== ASSESSMENT_STAGE_STATUS.EMAIL_VERIFIED
  }),
  { label: 'System check failed', value: 'SYSTEM_CHECK_FAILED' },
  { label: 'System check skipped', value: 'SYSTEM_CHECK_SKIPPED' },
  { label: 'System check passed', value: 'SYSTEM_CHECK_PASSED' },
  { label: 'System check pending', value: 'SYSTEM_CHECK_PENDING' }
]
export const REGISTRATION_TAB_STATUS = {
  INVITED: 'INVITED',
  REJECTED: 'REJECTED',
  ON_HOLD: 'ON_HOLD',
  RESUME_SCREENING: 'RESUME_SCREENING',
  ELIGIBLE: 'ELIGIBLE',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  DIRECT_INVITED: 'DIRECT_INVITED'
}

export const SORT_TYPE = {
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  DATE: 'DATE'
}
export const RE_ENABLE_ATTEMPT_MODE = {
  CONTINUE: 'CONTINUE',
  RESTART: 'RESTART'
}

export const PSYCHOMETRIC_CHALLENGE_OPTIONS = [
  { value: 'DISC', label: 'DISC Test' },
  { value: 'OCEAN', label: 'OCEAN (Big Five Personality) Test' }
]

export const FEATURE_CREDITS_TYPE = {
  AUXILIARY_DEVICE_PROCTORING: 'AUXILIARY_DEVICE_PROCTORING'
}

export const AUX_DEVICE_CREDIT_STAGE = Object.keys(CHALLENGE_TYPE_ID).filter(
  (value) =>
    value !== CHALLENGE_TYPES.PLACEMENT_TALK &&
    value !== CHALLENGE_TYPES.RESUME_FILTERING &&
    value !== CHALLENGE_TYPES.VIDEO_RESPONSE &&
    value !== CHALLENGE_TYPES.INTERVIEW
)
